export default __webpack_public_path__ + "f790f44c69072ea42a25761ab7e561d0.ttf";